/**

 * Confirmation email body templates for incoming email inboxes.

 * Placeholders: {{name}}, {{ticket_id}}

 *

 * Most templates rely on the automatic "Hi {{name}}," line in the email layout.

 * Templates with includesGreeting: true open with their own greeting instead.

 */

export const INCOMING_EMAIL_CONFIRMATION_TEMPLATES = [

	{

		id: 'standard',

		label: 'Standard receipt',

		includesGreeting: false,

		html: `<p>Thank you for reaching out — we've received your message and a support ticket (<strong>#{{ticket_id}}</strong>) has been opened on your behalf.</p>

<p>A member of our team will review your request and get back to you as soon as possible. You don't need to do anything else right now.</p>`,

	},

	{

		id: 'personal',

		label: 'Personal welcome',

		includesGreeting: true,

		html: `<p>Hi {{name}}, thanks for contacting us!</p>

<p>Your message has been received and ticket <strong>#{{ticket_id}}</strong> is now open. Our team has everything they need to help you.</p>

<p>We'll review your request and respond as soon as we can. Sit tight — we've got you covered.</p>`,

	},

	{

		id: 'professional',

		label: 'Professional brief',

		includesGreeting: false,

		html: `<p>This confirms that we have received your email and created support ticket <strong>#{{ticket_id}}</strong> for {{name}}.</p>

<p>Your request is in our queue and will be reviewed by a team member shortly. No further action is required from you at this time.</p>`,

	},

	{

		id: 'assurance',

		label: 'Support assurance',

		includesGreeting: false,

		html: `<p>Good news — your email made it to us safely.</p>

<p>We've logged it as ticket <strong>#{{ticket_id}}</strong> and assigned it to our support team. Someone will follow up with you as quickly as possible.</p>

<p>If you included any extra details, they're already attached to your ticket.</p>`,

	},

	{

		id: 'tracking',

		label: 'Progress tracking',

		includesGreeting: false,

		html: `<p>We've opened ticket <strong>#{{ticket_id}}</strong> for {{name}} and our team is on it.</p>

<p>While you wait, you can check the latest status and updates using the tracking link below — no account needed.</p>

<p>We appreciate your patience and will be in touch soon.</p>`,

	},

];



export function getDefaultIncomingEmailConfirmationHtml() {

	return INCOMING_EMAIL_CONFIRMATION_TEMPLATES[0].html;

}


